import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { MODAL_CLOSE } from 'redux/slices/modals';

import { Button, Icon } from 'ui/atoms';
import { Container } from 'ui/gridSystem';
import MainFont from 'ui/typography/mainFont';
import {
  IconClose,
  ModalGlobalContainer,
  ModalTitle,
  ModalWrapper
} from '../Modal.style';

import {
  LinkEmailMalito,
  ModalContainer,
  ModalContent,
  ModalHeader,
  RowCentered
} from './style';

import Modal, { stopEvent } from '../Modal';

const modalId = 'support';

const Support = ({ onClose }) => {
  const { t } = useTranslation();

  return (
    <Modal id={modalId}>
      <Container>
        <ModalWrapper>
          <ModalGlobalContainer
            onMouseDown={stopEvent}
            onClick={stopEvent}
            width="791px"
            height="auto"
          >
            <ModalTitle>
              <MainFont type="4" configuration={{ fontSize: 24 }}>
                {t('support_title')}
              </MainFont>
              <IconClose>
                <Icon type="icon-close-modal" size={20} onClick={onClose} />
              </IconClose>
            </ModalTitle>
            <ModalContainer>
              <ModalContent>
                <ModalHeader>
                  <MainFont type="description">
                    {t('support_contact_hours_first')}
                  </MainFont>
                  <MainFont type="description">
                    {t('from')} <b>{t('monday')}</b> {t('to')}{' '}
                    <b>{t('saturday')}</b>:
                  </MainFont>
                  <MainFont type="description">
                    <b>{t('support_contact_hours_last')}</b>
                  </MainFont>
                </ModalHeader>
                <MainFont type="description">
                  Italia <b>800 920 155</b>
                </MainFont>
                <MainFont type="description">
                  United Kingdom <b>+44 2034674457</b>
                </MainFont>
                <MainFont type="description">
                  France
                             <MainFont type="blueLabel" configuration={{fontWeight: 'bold', fontSize: 16}}> 
                             <LinkEmailMalito href="mailto:contact-reseau@f2m-esolutions.com"> contact-reseau@f2m-esolutions.com</LinkEmailMalito>
                             </MainFont>
                </MainFont>
                <MainFont type="description">
                  España <b>+34 518 90 05 24</b>
                </MainFont>
                <MainFont type="description">
                  Deutschland <b>+49 61424902997</b>
                </MainFont>
              </ModalContent>
            </ModalContainer>
            <RowCentered>
              <Button
                variant={'editaccountdata'}
                onClick={() => {
                  onClose();
                }}
              >
                {t('close')}
              </Button>
            </RowCentered>
          </ModalGlobalContainer>
        </ModalWrapper>
      </Container>
    </Modal>
  );
};

Support.propTypes = {
  onClose: PropTypes.func
};

Support.id = modalId;

export default connect(null, dispatch => ({
  onClose: () => dispatch(MODAL_CLOSE())
}))(Support);
